import { Pressable } from 'react-native';

import { Text } from '@/components/ui/Text';

/** A destructive row inside the Account "Danger zone". */
export function DangerRow({ label, onPress }: { label: string; onPress?: () => void }) {
  return (
    <Pressable onPress={onPress} className="px-4 py-3.5 active:opacity-70">
      <Text variant="none" className="font-sans-semibold text-base text-alert">
        {label}
      </Text>
    </Pressable>
  );
}
